// Adds swipe-indicator dots to the product gallery.
// Patches ProductSlider after it's registered so this file can load
// independently of product.js load order.
customElements.whenDefined('product-slider').then(function () {
  var PS = customElements.get('product-slider');
  if (!PS) return;

  PS.prototype.createDots = function () {
    if (!this.pagination) return;
    if (this.parentElement.querySelector('.product-images-dots')) return;
    var slides = this.querySelectorAll('[id^="Slide-"]');
    var count = slides.length;
    if (count < 2) return;

    var wrap = document.createElement('div');
    wrap.className = 'product-images-dots no-js-hidden';
    wrap.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('span');
      dot.className = 'product-images-dot' + (i === 0 ? ' is-active' : '');
      wrap.appendChild(dot);
    }
    this.pagination.after(wrap);
  };

  // Apply to any sliders already in the DOM
  document.querySelectorAll('product-slider').forEach(function (el) {
    el.createDots();
  });
});
